export const sidebarCurrentPanel = state => state.currentPanel;
export const sidebarActiveButton = state => state.activeButton;
export const sidebarCurrentElement = state => state.currentElement;

export const sidebarElementModifiers = (state, rootState) => {
  const element = state.currentElement;

  if (!element) {
    return [];
  }

  const item = element.getAttribute('klickbox-edit-item');

  if (!item || item === '') {
    return [];
  }

  return Object.keys(rootState.quizStyle(item));
};

export const sidebarElementItem = state => {
  const element = state.currentElement;

  if (!element) {
    return '';
  }

  return element.getAttribute('klickbox-edit-item');
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/sidebar/getters.js
 **/